import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="email-registration"
export default class extends Controller {
  static targets = ["form", "button"]

  connect() {
    // エラーメッセージがある場合は最初からフォームを表示
    const hasErrors = this.formTarget.querySelector(".alert-danger, .invalid-feedback")
    if (hasErrors) {
      this.showForm()
    }
  }

  showForm() {
    this.formTarget.classList.remove("d-none")
    this.buttonTarget.classList.add("d-none")
  }
}